// extracted by mini-css-extract-plugin
export var form = "_3z-0";